import { RoyalMailProvider, SmartSendProvider, Parcel2GoProvider } from '~/lib/consts/providers';
import { SettingsCache } from '~/lib/consts/settings-cache';

export function ProviderShortName(provider: string): string {
  switch (provider) {
    case RoyalMailProvider:
      return 'RM';
    default:
      return ProviderName(provider);
  }
}

export default function ProviderName(provider: string): string {
  switch (provider) {
    case SmartSendProvider: {
      if (SettingsCache.profile.startsWith('DHLPARCEL')) {
        return 'DHL';
      }

      if (SettingsCache.profile.startsWith('EVRI')) {
        return 'EVRi';
      }

      if (SettingsCache.profile.startsWith('FEDEX')) {
        return 'FedEx';
      }

      if (SettingsCache.profile.startsWith('POSTOFFICE')) {
        return 'Post Office';
      }

      if (SettingsCache.profile.startsWith('ASENDIA')) {
        return 'Asendia';
      }

      return SettingsCache.settings.SmartSend.SmartSendProviderName || 'Parcel2Go';
    }
    case Parcel2GoProvider:
      return 'Parcel2Go';
    case RoyalMailProvider:
      return 'Royal Mail';
    default:
      return provider;
  }
}
